import type { ItemTributoResponse, NovoItemTributoDto } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

export function useTributos(itemId: string | undefined) {
  return useConsulta<ItemTributoResponse[]>(['itens', itemId, 'tributos'], `/itens/${itemId}/tributos`, { ativo: !!itemId });
}

export function useNovoTributo() {
  return useMutacao<ItemTributoResponse, { itemId: string } & NovoItemTributoDto>({
    metodo: 'POST',
    caminho: (v) => `/itens/${v.itemId}/tributos`,
    corpo: ({ itemId: _i, ...resto }) => resto,
    invalidar: [['itens']],
  });
}
